<template>
	<div
		class="c-row-wrap"
		:class="{
			'c-row-wrap--non-flex': nonFlex
		}"
	>
		<slot></slot>
	</div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
	gutter: {
		type: Number,
		default: 0
	},
	nonFlex: {
		type: Boolean,
		default: false
	}
});
const composeRowGutter = computed(() => {
	return `${props.gutter}px`;
});
</script>

<style lang="less" scoped>
.c-row-wrap {
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;

	/deep/ .c-col-wrap {
		flex: 1;

		& + .c-col-wrap {
			margin-left: v-bind(composeRowGutter);
		}
	}

	&--non-flex {
		display: block;

		/deep/ .c-col-wrap {
			margin-left: 0 !important;
		}
	}
}
</style>
